module.exports = __webpack_public_path__ + "static/media/subICloud5.beb528d0.png";